export enum GuestStatus {
  DEFAULT = 'default',
  ACTION_REQUIRED = 'action_required',
  ATTENDED = 'attended',
  CANCELLED = 'cancelled',
  CONFIRMED = 'confirmed',
  CONFIRMED_WITH_INCOMPLETE_SURVEY = 'confirmed_with_incomplete_survey',
  INTERESTED = 'interested',
  INVITED = 'invited',
  WAITLISTED = 'waitlisted',
  NONE = 'none',
  UNINVITED = 'UNINVITED'
}

export enum GuestType {
  EPOCH = 'epoch',
  EXTERNAL_ZOOM = 'external-zoom',
  EXTERNAL_MEET = 'external-meet',
  EXTERNAL_ZOOM_WITHOUT_EMAIL = 'external-zoom-without-email',
  EXTERNAL_MEET_WITHOUT_EMAIL = 'external-meet-without-email'
}
